// extracted by mini-css-extract-plugin
module.exports = {"list":"BlogOverviewTemplate_list__S2Q1I","contentWrapper":"BlogOverviewTemplate_contentWrapper__Sx1mZ"};